import { CheckboxGroupPresenter } from '@/forms/components/presenters/CheckboxGroupPresenter';
import {
  FormFieldType,
  type CheckboxGroupFormField,
  type FileFormField,
  type SingleFormField,
} from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildCheckboxGroupInitialState } from './initialState';

export const checkboxGroupFieldModule: FormFieldModule = {
  type: FormFieldType.CheckboxGroup,
  Presenter: ({ field }) => (
    <CheckboxGroupPresenter field={field as CheckboxGroupFormField} />
  ),
  flattenLeaves: field =>
    (field as CheckboxGroupFormField).fields as Array<SingleFormField | FileFormField>,
  buildInitialState: buildCheckboxGroupInitialState,
};
